import { writable } from 'svelte/store';

const handleKeydown = (event) => {
	if (event.key === 'Escape') {
		nav.hide();
	}
};

export const navWasIsVisibleOnce = writable(false);

function createNav() {
	const { subscribe, update } = writable(false);

	return {
		subscribe,
		show: () =>
			update((n) => {
				document.documentElement.classList.add('overflow-hidden');
				window.addEventListener('keydown', handleKeydown);
				navWasIsVisibleOnce.set(true);
				return true;
			}),
		hide: () =>
			update((n) => {
				document.documentElement.classList.remove('overflow-hidden');
				window.removeEventListener('keydown', handleKeydown);
				return false;
			}),
	};
}

export const nav = createNav();
export const siteTitle = writable('');
export const footerIsVisible = writable(true);
export const campaignsExpanded = writable(false);
